import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Handshake } from "lucide-react";

export const Route = createFileRoute("/admin/partners")({
  component: () => (
    <StubAdminPage
      icon={Handshake}
      title="Partners"
      subtitle="Business partners and API integrations"
    />
  ),
});
